
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/music/collection/[...collectionSlug]",
      function () {
        return require("private-next-pages/music/collection/[...collectionSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/music/collection/[...collectionSlug]"])
      });
    }
  